import VoiceSelectorModalBase from "@/components/modal/voice-selector/base/voice-selector-modal-base";
import BlendingVoiceSelector from "@/components/common/voice-selector/selectors/blending-voice-selector";
import { VoiceModel } from "@/actions/db/get-models";

type BlendingVoiceSelectorModalProps = {
  otherVoice?: VoiceModel;
  handleVoiceModelClick: (voice: VoiceModel) => void;
};

const BlendingVoiceSelectorModal = ({
  otherVoice,
  handleVoiceModelClick,
}: BlendingVoiceSelectorModalProps) => {
  return (
    <VoiceSelectorModalBase>
      <BlendingVoiceSelector
        otherVoice={otherVoice}
        handleVoiceModelClick={handleVoiceModelClick}
      />
    </VoiceSelectorModalBase>
  );
};

export default BlendingVoiceSelectorModal;
